<template>
  <div class="moveDialog">
    <el-dialog
      title="外接设备"
      :visible.sync="status"
      width="30%"
      :close-on-click-modal="false"
    >
      <p><img src="../img/moveIcon.png" />外接设备</p>

        <el-table
          :data="outList"
          stripe
          style="width: 100%;">
          <el-table-column
            prop="type"
            label="设备型号"
          >
          </el-table-column>
          <el-table-column
            prop="id"
            label="设备id"
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="设备名称"
          >
          </el-table-column>
          <el-table-column
           label="操作"
          >
            <template slot-scope="scope">

              <el-button type="text" size="small" @click="desinout(scope.row)">编辑</el-button>
              <el-button type="text" size="small" @click="deleteout(scope.row)">删除</el-button>

            </template>
          </el-table-column>
        </el-table>



      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="addout()">手动添加</el-button>
        <el-button @click="status = false">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="outtitle" :close-on-click-modal="false"  :visible.sync="addoutDialog" width="550px">
      <el-form ref="outFormData" :rules="rules" :model="outequ"  label-width="90px">
        <el-form-item label="设备类型" prop="type">
          <el-select style="width: 420px;"   v-model="outequ.type" placeholder="请选择设备类型">
            <el-option

              v-for="item in outtypeList"
              :key="item"
              :label="item"
              :value="item">
            </el-option>

          </el-select>
        </el-form-item>

        <el-form-item label="设备id" prop="id">
          <el-input v-model="outequ.id" />
        </el-form-item>
        <el-form-item label="设备名称" prop="name">
          <el-input v-model="outequ.name" />
        </el-form-item>
      </el-form>
      <div style="text-align:right;" >
        <el-button type="primary" @click="addoutequ()">保存</el-button>
        <el-button @click="addoutDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Axios from "@/utils/Axios";
export default {
  name: "moveDialog",
  data() {
    return {
      status: false,
      addoutDialog: false,
      outterminalId:"",
      outList:[],
      outtypeList:[],
      outtitle:"",
      outequ:{
        id:"",
        name:"",
        terminalId:"",
        type:"",
      },
      rules: {
        protocol: [
          { required: true, message: '请选择协议类型', trigger: 'blur' },
        ],
        addr485: [
          { required: true, message: '请输入位置', trigger: 'blur' },
        ],
        imei: [
          { required: true, message: '请输入imei', trigger: 'blur' },
        ],
        hostTerminalImei: [
          { required: true, message: '请输入宿主机imei', trigger: 'blur' },
        ],
        enableStatus: [
          { required: true, message: '请选择状态', trigger: 'blur' },
        ],
        deptNamelist: [
          { required: true, message: '请选择单位', trigger: 'blur' },
        ],
        terminalTypeName: [
          { required: true, message: '请选择型号', trigger: 'blur' },
        ],
      },
    };
  },
  methods: {
    addoutequ(){
      let that = this;
      let param = {};
      param.method="post";
      if(  this.outtitle=='新增设备' || this.outtitle=='new equipment'){
        param.url="/peripherals/add";
      }else if(   this.outtitle=='编辑设备' || this.outtitle=='Edit equipment'){
        param.url="/peripherals/edit";
      }

      param.data=
        {
          "id": this.outequ.id,
          "name":  this.outequ.name,
          "terminalId": this.outterminalId,
          "type": this.outequ.type
        }
      Axios.ajax(param).then((res)=>{
        if(res.resultCode=='0'){
          that.$message({
            type: 'success',
            message: res.resultMessage
          });
          this.addoutDialog=false
          this.getOutlist(this.outterminalId)
        }else{
          that.$message({
            type: 'error',
            message: res.resultMessage
          });
        }
      })
    },
    addout(){
      this.outequ={
        id:"",
        name:"",
        terminalId:"",
        type:"",
      }
      this.addoutDialog=true
      this.outtitle="新增设备"
    },
    deleteout(data){
      let that = this;
      let param = {};
      this.$confirm("确认删除？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: 'warning'
      }).then(() => {
        param.method="delete";
        param.url="/peripherals/remove";
        param.params=
          {
            "id": data.id,
          }
        Axios.ajax(param).then((res)=>{
          if(res.resultCode=='0'){
            that.$message({
              type: 'success',
              message: "删除成功"
            });

            that.getOutlist(this.outterminalId)
          }else{
            that.$message({
              type: 'error',
              message: res.resultMessage
            });
          }
        })
      })

    },
    desinout(data){
      this.outequ=data
      this.outtitle="编辑设备"
      this.addoutDialog=true
    },
    getOutlist(terminalId){
      let that = this;
      let param = {};
      param.method="get";
      param.url="/peripherals/list/"+terminalId;
      param.params=
        {

        }
      Axios.ajax(param).then((res)=>{
        this.outList=res.data

      })
    },
    getOuttype(data){
      let that = this;
      let param = {};
      param.method="get";
      param.url="/peripherals/types";
      param.params=
        {

        }
      Axios.ajax(param).then((res)=>{
        this.outtypeList=res.data
      })
    },
    controlDialog(data) {
      this.status = true;
      this.outterminalId=data.terminalId
      this.getOutlist(data.terminalId)
      this.getOuttype(data.terminalId)
    },
  },
};
</script>

<style lang="less" scoped>
.moveDialog {
  p {
    margin: 0 0 10px 0;
    height: 30px;
    line-height: 10px;
    img {
      margin-right: 12px;
    }
  }
}
</style>
